import {
  Links,
  Meta,
  Outlet,
  redirect,
  Scripts,
  ScrollRestoration,
  useLoaderData,
} from "@remix-run/react";
import { I18nContext, I18nManager } from "@shopify/react-i18n";
import {
  DEFAULT_LOCALE,
  handleGuestLocale,
  handleSessionLocale,
} from "~/data/locale.server";
import { validateShopifySession } from "./shopify.server";

export const loader = async ({ request }) => {
  let { session } = await validateShopifySession(request);
  if (
    !session &&
    new URL(request.url).pathname.startsWith("/app/") &&
    !new URL(request.url).searchParams.get("shop")
  ) {
    return redirect("/?unauthorized=true");
  }

  let locale = DEFAULT_LOCALE;
  if (session) {
    locale = await handleSessionLocale(request, session);
  } else {
    locale = handleGuestLocale(request);
  }

  const headers = new Headers();
  if (!session) {
    headers.append("Set-Cookie", `locale=${locale}; Path=/;`);
  }

  return Response.json({ locale }, { headers });
};

function I18nProviderWrapper({ children }) {
  const { locale } = useLoaderData();

  return (
    <I18nContext.Provider
      value={
        new I18nManager({
          locale,
          onError(error) {
            console.error(error);
          },
        })
      }
    >
      {children}
    </I18nContext.Provider>
  );
}

export default function App() {
  return (
    <I18nProviderWrapper>
      <html data-theme="light">
        <head>
          <meta charSet="utf-8" />
          <meta name="viewport" content="width=device-width,initial-scale=1" />
          <link rel="preconnect" href="https://cdn.shopify.com/" />
          <link
            rel="stylesheet"
            href="https://cdn.shopify.com/static/fonts/inter/v4/styles.css"
          />
          <Meta />
          <Links />
        </head>
        <body>
          <Outlet />
          <ScrollRestoration />
          <Scripts />
        </body>
      </html>
    </I18nProviderWrapper>
  );
}
